/**
 * The week can arrive before the PDP link and the cost-cap button are known.
 * While the payload says so, the page asks for the same saved week again —
 * not a new read of every account — until the buttons are on the rows.
 */

export const EXTRAS_POLL_MS = 3000;
export const EXTRAS_POLL_TRIES = 40;

// Same fields the server merges onto a campaign row. A refresh that has not
// read them yet must not wipe the ones already on screen.
export const EXTRAS_KEYS = [
  'pdp',
  'bidSource',
  'bidTargetGroups',
  'bidMinGroups',
  'bidRoasGroups',
  'bidRoasFloor',
  'bidGoal',
  'bidMixed',
  'bidNotSet',
  'bidGroupsSeen',
  'metaAdsets',
];

export function shouldPollExtras(data, tries) {
  return data?.campaignExtras === 'pending' && tries < EXTRAS_POLL_TRIES;
}

/**
 * Keep the PDP link and the cost cap when a newer week payload has not read
 * them yet. A key the new row already has, including an empty link list,
 * wins. Spend and status always come from the new payload.
 */
export function preserveCampaignExtras(prev, next) {
  if (!prev?.campaigns || !next?.campaigns) return next;
  const byId = new Map(prev.campaigns.map((c) => [String(c?.id), c]));
  let kept = false;
  const campaigns = next.campaigns.map((c) => {
    const old = byId.get(String(c?.id));
    if (!old) return c;
    let row = c;
    for (const key of EXTRAS_KEYS) {
      if (Object.prototype.hasOwnProperty.call(c, key)) continue;
      if (!Object.prototype.hasOwnProperty.call(old, key)) continue;
      if (row === c) row = { ...c };
      row[key] = old[key];
      kept = true;
    }
    return row;
  });
  return kept ? { ...next, campaigns } : next;
}
